import { WhiteCross } from '@randstad-lean-mobile-factory/react-components-ui-shared';
import { createPortal } from 'react-dom';
import { ToastContainer as PackageToastContainer } from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';

import { Props } from './ToastContainer.types';

export const ToastContainer = ({ closeButton = true, position }: Props) => {
  return createPortal(
    <PackageToastContainer
      autoClose={3000}
      closeOnClick
      closeButton={closeButton ? <WhiteCross /> : false}
      draggable={false}
      hideProgressBar={true}
      position={position}
      style={{ width: '30.5rem' }}
    />,
    document.body
  );
};
